import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Maximize2, Check } from "lucide-react";
import { useSaunaBasePrice } from "../hooks/useSaunaBasePrice";

const galleryImages = {
  exterior: [
    "https://myodoo-pl-lykke.odoo.com/web/image/16838-946abc4b/nano%20mobile.jpeg?access_token=af9ee5ae-d560-4062-942f-d860a7634e00",
    "https://myodoo-pl-lykke.odoo.com/web/image/16839-f70ed3d6/nano%20mobile.jpg?access_token=2a00e0bd-ac3a-40e2-8a51-ea8aa339c212",
    "https://myodoo-pl-lykke.odoo.com/web/image/16840-d31b8bb0/nano%20mobile%20%288%29.jpg?access_token=59152391-3876-49b1-893e-5fd15296cf56",
    "https://myodoo-pl-lykke.odoo.com/web/image/16841-70ffd7ca/nano%20mobile%20%286%29.jpg?access_token=e9156ee4-edf7-45b5-adf8-96117a37aca3",
  ],
  interior: [
    "https://myodoo-pl-lykke.odoo.com/web/image/16842-0f502355/nano%20mobile%20%282%29.webp?access_token=fc19504e-1879-4478-9a27-99fbeb747e7e",
    "https://myodoo-pl-lykke.odoo.com/web/image/16843-4792ceb4/nano%20mobile%20%283%29.webp?access_token=738be7d4-1d9b-4364-8151-160b592b105f",
    "https://myodoo-pl-lykke.odoo.com/web/image/16844-9366e65d/nano%20mobile%20%2810%29.jpg?access_token=c4e964e5-3e97-4a51-ac56-b19a0ba68dff",
    "https://myodoo-pl-lykke.odoo.com/web/image/16845-b4efac54/nano%20mobile%20%289%29.jpg?access_token=b543f623-f192-4a71-a106-089514f0f580",
  ],
  details: [
    "https://myodoo-pl-lykke.odoo.com/web/image/16846-f7e920be/nano%20mobile%20%287%29.jpg?access_token=8f4fcb58-1ce3-4a49-a47f-6b5bd374c4f5",
    "https://myodoo-pl-lykke.odoo.com/web/image/16847-b7d9d415/nano%20mobile%20%282%29.jpg?access_token=7ce1cb48-b439-43dd-af5c-21ff4f3c216f",
    "https://myodoo-pl-lykke.odoo.com/web/image/16848-a052501c/nano%20mobile%20%283%29.jpg?access_token=19723e95-43c6-46d5-a751-04a251479616",
    "https://myodoo-pl-lykke.odoo.com/web/image/16849-2359a410/nano%20mobile%20%284%29.jpg?access_token=3cf60b55-5b7a-4693-ba01-d7629b6bec09",
  ],
  all: [
    "https://myodoo-pl-lykke.odoo.com/web/image/16838-946abc4b/nano%20mobile.jpeg?access_token=af9ee5ae-d560-4062-942f-d860a7634e00",
    "https://myodoo-pl-lykke.odoo.com/web/image/16839-f70ed3d6/nano%20mobile.jpg?access_token=2a00e0bd-ac3a-40e2-8a51-ea8aa339c212",
    "https://myodoo-pl-lykke.odoo.com/web/image/16840-d31b8bb0/nano%20mobile%20%288%29.jpg?access_token=59152391-3876-49b1-893e-5fd15296cf56",
    "https://myodoo-pl-lykke.odoo.com/web/image/16841-70ffd7ca/nano%20mobile%20%286%29.jpg?access_token=e9156ee4-edf7-45b5-adf8-96117a37aca3",
    "https://myodoo-pl-lykke.odoo.com/web/image/16842-0f502355/nano%20mobile%20%282%29.webp?access_token=fc19504e-1879-4478-9a27-99fbeb747e7e",
    "https://myodoo-pl-lykke.odoo.com/web/image/16843-4792ceb4/nano%20mobile%20%283%29.webp?access_token=738be7d4-1d9b-4364-8151-160b592b105f",
    "https://myodoo-pl-lykke.odoo.com/web/image/16844-9366e65d/nano%20mobile%20%2810%29.jpg?access_token=c4e964e5-3e97-4a51-ac56-b19a0ba68dff",
    "https://myodoo-pl-lykke.odoo.com/web/image/16845-b4efac54/nano%20mobile%20%289%29.jpg?access_token=b543f623-f192-4a71-a106-089514f0f580",
    "https://myodoo-pl-lykke.odoo.com/web/image/16846-f7e920be/nano%20mobile%20%287%29.jpg?access_token=8f4fcb58-1ce3-4a49-a47f-6b5bd374c4f5",
    "https://myodoo-pl-lykke.odoo.com/web/image/16847-b7d9d415/nano%20mobile%20%282%29.jpg?access_token=7ce1cb48-b439-43dd-af5c-21ff4f3c216f",
    "https://myodoo-pl-lykke.odoo.com/web/image/16848-a052501c/nano%20mobile%20%283%29.jpg?access_token=19723e95-43c6-46d5-a751-04a251479616",
    "https://myodoo-pl-lykke.odoo.com/web/image/16849-2359a410/nano%20mobile%20%284%29.jpg?access_token=3cf60b55-5b7a-4693-ba01-d7629b6bec09",
    "https://myodoo-pl-lykke.odoo.com/web/image/16850-6aae05b2/nano%20mobile.webp?access_token=cc49e488-83b3-4237-b9a2-0d2f3fe921b1",
  ],
};

const otherProducts = [
  { label: "UMI", href: "/sauna-umi", img: "https://media.base44.com/images/public/69a726345560d5ef49a37111/2bea1da1e_LYKKEUMI.jpg" },
  { label: "MORI", href: "/sauna-mori", img: "https://media.base44.com/images/public/69a726345560d5ef49a37111/4557c280d_LYKKE_MORI_1.jpg" },
  { label: "HIRO", href: "/sauna-hiro", img: "https://media.base44.com/images/public/69a726345560d5ef49a37111/3d5fe43e4_HIRO_1.jpg" },
  { label: "DOLOMITI", href: "/sauna-dolomiti", img: "https://media.base44.com/images/public/69a726345560d5ef49a37111/c109e0135_Dolomiti_Thermo2.jpg" },
];

function LightboxGallery({ images, initialIndex, onClose }) {
  const [idx, setIdx] = useState(initialIndex);
  return (
    <div className="fixed inset-0 bg-black z-50 flex flex-col" onClick={onClose}>
      <button onClick={onClose} className="absolute top-6 right-8 text-white/70 hover:text-white text-3xl z-10">×</button>
      <div className="flex-1 flex items-center justify-center relative" onClick={e => e.stopPropagation()}>
        <AnimatePresence mode="wait">
          <motion.img
            key={idx}
            src={images[idx]}
            alt=""
            className="max-h-[85vh] max-w-[90vw] object-contain"
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.97 }}
            transition={{ duration: 0.25 }}
          />
        </AnimatePresence>
        <button onClick={() => setIdx(i => (i - 1 + images.length) % images.length)} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/60 hover:text-white p-2"><ChevronLeft size={32} /></button>
        <button onClick={() => setIdx(i => (i + 1) % images.length)} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/60 hover:text-white p-2"><ChevronRight size={32} /></button>
      </div>
      <div className="flex gap-2 justify-center py-4 overflow-x-auto px-4">
        {images.map((img, i) => (
          <button key={i} onClick={e => { e.stopPropagation(); setIdx(i); }} className={`flex-shrink-0 w-14 h-10 overflow-hidden transition-all ${i === idx ? 'ring-2 ring-white' : 'opacity-40 hover:opacity-70'}`}>
            <img src={img} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
}

export default function SaunaNomad() {
  const { basePrice: price } = useSaunaBasePrice('LYKKE NANO NOMAD', 37000);
  const [lightbox, setLightbox] = useState(null);
  const [activeGallery, setActiveGallery] = useState('exterior');
  const stickyRef = useRef(null);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} className="bg-[#f5f4f0]">
      <Navbar />

      {/* ── HERO ── */}
      <div className="relative w-full h-[75vh] md:h-[90vh] overflow-hidden">
        <img
          src={galleryImages.exterior[0]}
          alt="LYKKE NANO NOMAD"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent pointer-events-none" />

        <div className="absolute bottom-0 left-0 px-8 md:px-16 pb-14 md:pb-20">
          <p className="text-white/60 text-xs tracking-[0.3em] uppercase font-body mb-3">KOLEKSJON</p>
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-light text-white leading-[1] mb-3">
            LYKKE NANO
          </h1>
          <p className="font-heading text-3xl md:text-5xl italic text-white/70 font-light leading-tight mb-4">
            Tiny House skandinavski stil
          </p>
          <p className="text-white/60 text-lg md:text-xl tracking-[0.2em] uppercase font-body">
            NØKKELFERDIG · MOBIL · 660 × 255 × 300 CM
          </p>
        </div>
      </div>

      {/* ── OVERVIEW: sticky left + specs right ── */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-16 items-start">

          {/* LEFT — sticky overview */}
          <div ref={stickyRef} className="md:sticky md:top-32">
            <p className="text-xs tracking-[0.25em] uppercase text-foreground/50 mb-4 font-body">LYKKE NOMAD · Tiny House</p>
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-light leading-[1.05] mb-6">
              NANO<br />
              <span className="italic opacity-40 text-4xl md:text-5xl">Mobil hjem</span>
            </h1>
            <p className="text-foreground/60 leading-relaxed mb-10 text-base max-w-sm">
              Komplett nøkkelferdig Tiny House med skandinavisk design. Kjøkken, bad, stue og soverom på ca. 20 m². Ideell som fritidshus, hagekontor eller mobil B&B.
            </p>

            {/* Spec table */}
            <div className="space-y-0 border-t border-foreground/10 mb-10">
              {[
                ["Størrelse", "Ca. 20 m² (16 m² bruksareal)"],
                ["Startpris", `Fra €${price.toLocaleString('nb-NO')}`],
                ["Leveringstid", "12–16 uker"],
                ["Personer", "Komfortabelt 2"],
                ["Fasade", "Galvanisert stål / termofuru"],
                ["Energi", "Inverter klimaanlegg 12000 BTU"],
                ["Utstyr", "Komplett nøkkelferdig"],
              ].map(([label, val]) => (
                <div key={label} className="grid grid-cols-2 border-b border-foreground/10 py-2.5 gap-4">
                  <span className="text-lg text-foreground/40 font-body tracking-wide">{label}</span>
                  <span className="text-xl text-foreground font-body font-medium">{val}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="flex flex-col gap-3">
              <button
                onClick={() => window.location.href = "/be-om-tilbud"}
                className="w-full md:w-auto px-10 py-4 bg-foreground text-background text-sm tracking-[0.15em] uppercase font-body hover:bg-foreground/85 transition-all duration-200 rounded-sm"
              >
                Be om tilbud
              </button>
              <p className="text-base text-foreground/60 font-body">
                Spørsmål?{" "}
                <a href="/be-om-tilbud" className="underline hover:text-foreground transition-colors">Be om tilbud</a>
                {" "}eller{" "}
                <a href="/om-oss" className="underline hover:text-foreground transition-colors">kontakt oss</a>.
              </p>
            </div>
          </div>

          {/* RIGHT — highlight key points */}
          <div className="space-y-10 pt-2">
            <div className="bg-[#f0ede6] rounded-lg p-6">
              <h3 className="font-heading text-2xl font-light mb-4">Fleksibelt og mobilt</h3>
              <ul className="space-y-3 text-foreground/60">
                <li className="flex gap-3">
                  <Check className="w-5 h-5 text-[#4a8f63] flex-shrink-0" />
                  <span>Montert på godkjent tilhenger — lett å transportere</span>
                </li>
                <li className="flex gap-3">
                  <Check className="w-5 h-5 text-[#4a8f63] flex-shrink-0" />
                  <span>Kun registrering påkrevd — ingen byggetillatelse</span>
                </li>
                <li className="flex gap-3">
                  <Check className="w-5 h-5 text-[#4a8f63] flex-shrink-0" />
                  <span>Nøkkelferdig fra dag én</span>
                </li>
                <li className="flex gap-3">
                  <Check className="w-5 h-5 text-[#4a8f63] flex-shrink-0" />
                  <span>10 års garanti på konstruksjonen</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-lg p-6 border border-blue-100">
              <h3 className="font-heading text-2xl font-light mb-4">Energieffektivt</h3>
              <p className="text-foreground/60 mb-4">Inverter klimaanlegg 12000 BTU (A++) med Wi-Fi-kontroll — minimalt strømforbruk og maksimalt komfort året rundt.</p>
              <p className="text-sm text-foreground/50">Mulighet for solcellepaneler til off-grid drift.</p>
            </div>

            <div className="p-6 border border-foreground/10">
              <h3 className="font-heading text-xl font-light mb-3">Tilgjengelige materialer</h3>
              <div className="space-y-2 text-foreground/60 text-sm">
                <p><strong>Fasade:</strong> Galvanisert stål eller termofuru</p>
                <p><strong>Interiør:</strong> Naturlig tre, moderne design</p>
                <p><strong>Vinduer:</strong> PVC Salamander, energieffektive</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── GALLERY TABS ── */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-8 border-b border-foreground/10">
        <div className="flex gap-4 md:gap-8 overflow-x-auto pb-4">
          {[
            { id: 'exterior', label: 'Eksteriør' },
            { id: 'interior', label: 'Interiør' },
            { id: 'details', label: 'Detaljer' },
            { id: 'all', label: 'Alle bilder' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveGallery(tab.id)}
              className={`font-body text-sm tracking-[0.15em] uppercase whitespace-nowrap pb-3 transition-all ${
                activeGallery === tab.id
                  ? 'text-foreground border-b-2 border-foreground'
                  : 'text-foreground/50 hover:text-foreground'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── PHOTO GRID GALLERY ── */}
      <div className="px-1 py-12">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeGallery}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-1"
          >
            {galleryImages[activeGallery].map((img, i) => (
              <div
                key={i}
                className="overflow-hidden cursor-pointer"
                style={{ height: '280px' }}
                onClick={() => setLightbox({ images: galleryImages.all, idx: i })}
              >
                <img src={img} alt={`Galeria ${i + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />
              </div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* ── DIVIDER TEXT SECTION ── */}
      <div className="bg-[#f0ede6] py-20 md:py-24 mt-20 md:mt-24">
        <div className="max-w-[900px] mx-auto px-6 md:px-12 text-center">
          <p className="text-xs tracking-[0.3em] uppercase text-foreground/40 font-body mb-6">FLEKSIBILITET</p>
          <h2 className="font-heading text-3xl md:text-5xl font-light leading-[1.2] mb-6">
            Et mobilt hjem<br /><em>tilpasset dine behov</em>
          </h2>
          <p className="text-foreground/60 text-lg leading-relaxed max-w-xl mx-auto">
            Nano NOMAD fungerer som fullverdig leilighet fra første dag — komplett nøkkelferdig med kjøkken, bad og alle installasjoner. Bruk den som fritidshus, hagekontor eller mobil B&B.
          </p>
        </div>
      </div>

      {/* ── NØKKELPUNKTER ── */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid md:grid-cols-3 gap-10 mb-16">
          {[
            {
              title: "Nøkkelferdig fra dag én",
              text: "Komplett utstyrt med kjøkken, bad, dusj, toalett, LED-belysning og alle installasjoner. Ingen byggefaser, bare se det og bruk det."
            },
            {
              title: "Energieffektivt",
              text: "Inverter klimaanlegg 12000 BTU med Wi-Fi (A++), LED-belysning i klasse A+, og mulighet for solcellepaneler til off-grid drift."
            },
            {
              title: "Mobil og fleksibel",
              text: "Montert på godkjent tilhenger. Lett å transportere og plassere. Påkrevd kun registrering — ingen byggetillatelse nødvendig."
            },
            {
              title: "Skandinavisk design",
              text: "Naturlig tre, galvanisert stål og minimalistisk estetikk. Fasade i termofuru eller stål — velg din stil."
            },
            {
              title: "Robust og holdbar",
              text: "10 års garanti på konstruksjonen. Fasade beskyttet med finsk olje/maling. Anbefalt vedlikehold hvert 8–10 år."
            },
            {
              title: "Fleksibel bruk",
              text: "Fritidshus, hagekontor, mobil B&B — eller permanent bolig. Tilpass den dine behov og vis den hvor du vil."
            },
          ].map((item) => (
            <motion.div key={item.title} whileHover={{ y: -8 }} transition={{ duration: 0.3 }}>
              <div className="flex gap-3">
                <Check className="w-5 h-5 text-[#4a8f63] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-heading text-xl font-normal mb-3">{item.title}</h3>
                  <p className="text-foreground/60 text-lg leading-relaxed">{item.text}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* ── SPECYFIKACJA TECHNICZNA ── */}
      <div className="bg-[#f0ede6] py-20 md:py-24">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <h2 className="font-heading text-3xl md:text-5xl font-light leading-[1.2] mb-12">Pełna specyfikacja</h2>
          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-8">
              <div>
                <h3 className="font-heading text-xl font-light mb-4 border-b border-foreground/20 pb-3">Wymiary i pojemność</h3>
                <dl className="space-y-3 text-foreground/60">
                  <div className="flex justify-between"><dt className="font-body">Wymiary zewnętrzne</dt><dd className="text-foreground font-medium">660 × 255 × 300 cm</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Wymiary wewnętrzne</dt><dd className="text-foreground font-medium">620 × 205 × 280 cm</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Powierzchnia użytkowa</dt><dd className="text-foreground font-medium">Ca. 16 m²</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Łazienka</dt><dd className="text-foreground font-medium">Ca. 2,82 m²</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Pojemność</dt><dd className="text-foreground font-medium">2 osoby komfortowo</dd></div>
                </dl>
              </div>

              <div>
                <h3 className="font-heading text-xl font-light mb-4 border-b border-foreground/20 pb-3">Izolacja i szczelność</h3>
                <dl className="space-y-3 text-foreground/60">
                  <div className="flex justify-between"><dt className="font-body">Ściany</dt><dd className="text-foreground font-medium">Mineralwełna 100 mm</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Dach</dt><dd className="text-foreground font-medium">Mineralwełna 150 mm</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Podłoga</dt><dd className="text-foreground font-medium">EPS 100 mm</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Paroizolacja</dt><dd className="text-foreground font-medium">Hunton Intello Plus</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Wiatroodporność</dt><dd className="text-foreground font-medium">BILKA 150 g/m²</dd></div>
                </dl>
              </div>
            </div>

            <div className="space-y-8">
              <div>
                <h3 className="font-heading text-xl font-light mb-4 border-b border-foreground/20 pb-3">Instalacje i systemy</h3>
                <dl className="space-y-3 text-foreground/60">
                  <div className="flex justify-between"><dt className="font-body">Elektryka</dt><dd className="text-foreground font-medium">230V kompletna</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Klimatyzacja</dt><dd className="text-foreground font-medium">Daewoo 12000 BTU A++</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Woda ciepła</dt><dd className="text-foreground font-medium">Ariston 30L, 1500W</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Wentylacja</dt><dd className="text-foreground font-medium">RECDUO 100 z odzyskiem</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Oświetlenie</dt><dd className="text-foreground font-medium">LED wewnątrz i na zewnątrz</dd></div>
                </dl>
              </div>

              <div>
                <h3 className="font-heading text-xl font-light mb-4 border-b border-foreground/20 pb-3">Materiały fasady</h3>
                <dl className="space-y-3 text-foreground/60">
                  <div className="flex justify-between"><dt className="font-body">Standard</dt><dd className="text-foreground font-medium">Blacha ocynkowana Lindab</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Opcjonalnie</dt><dd className="text-foreground font-medium">Drewno modyfikowane termicznie</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Dach</dt><dd className="text-foreground font-medium">Blacha na rąbek RAL 6011</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Okna</dt><dd className="text-foreground font-medium">PVC Salamander antracyt</dd></div>
                  <div className="flex justify-between"><dt className="font-body">Drzwi</dt><dd className="text-foreground font-medium">Zewnętrzne + HDF wewnętrzne</dd></div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── GWARANCJA I SERWIS ── */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="bg-[#f0ede6] rounded-lg p-8 h-full">
              <h3 className="font-heading text-2xl font-light mb-4">10 lat gwarancji</h3>
              <p className="text-foreground/60 leading-relaxed">Pełna gwarancja na konstrukcję przez 10 lat od daty dostawy.</p>
            </div>
          </div>
          <div>
            <div className="bg-[#f0ede6] rounded-lg p-8 h-full">
              <h3 className="font-heading text-2xl font-light mb-4">2 lata AGD</h3>
              <p className="text-foreground/60 leading-relaxed">Gwarancja na wszystkie białe urządzenia i systemy RTV od producenta.</p>
            </div>
          </div>
          <div>
            <div className="bg-[#f0ede6] rounded-lg p-8 h-full">
              <h3 className="font-heading text-2xl font-light mb-4">Konserwacja</h3>
              <p className="text-foreground/60 leading-relaxed">Fasada: ochrona olejami/lakierami fińskimi. Przegląd co 8–10 lat.</p>
            </div>
          </div>
        </div>
      </div>

      {/* ── ORDER CTA ── */}
      <div className="bg-[#f0ede6] py-24 md:py-32">
        <div className="max-w-[800px] mx-auto px-6 md:px-12 text-center">
          <p className="text-xs tracking-[0.3em] uppercase text-foreground/40 font-body mb-6">NESTE STEG</p>
          <h2 className="font-heading text-3xl md:text-5xl font-light leading-[1.2] mb-6">
            Klar for ditt nye hjem?
          </h2>
          <p className="text-foreground/60 text-xl leading-relaxed mb-12 max-w-xl mx-auto">
            Be om tilbud eller kontakt oss direkte for mer informasjon om LYKKE NANO NOMAD, individuelle tilpasninger og leveringsbetingelser.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.location.href = "/be-om-tilbud"}
              className="px-10 py-4 bg-foreground text-background text-sm tracking-[0.15em] uppercase font-body hover:bg-foreground/85 transition-all duration-200 rounded-sm"
            >
              Be om tilbud
            </button>
            <button
              onClick={() => window.location.href = "/om-oss"}
              className="px-10 py-4 border border-foreground/30 text-foreground text-sm tracking-[0.15em] uppercase font-body hover:bg-foreground hover:text-background transition-all duration-200 rounded-sm"
            >
              Kontakt oss
            </button>
          </div>
        </div>
      </div>

      {/* ── BROWSE RANGE ── */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pb-24">
        <h2 className="font-heading text-3xl font-light mb-10">Andre produkter</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {otherProducts.map((product) => (
            <a
              key={product.label}
              href={product.href}
              className="group block overflow-hidden"
            >
              <div className="aspect-[3/4] overflow-hidden mb-3 rounded-sm">
                <img
                  src={product.img}
                  alt={product.label}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between">
                <span className="font-heading text-xl font-light">{product.label}</span>
                <span className="text-sm text-foreground/40 group-hover:text-foreground transition-colors tracking-widest uppercase font-body">Se →</span>
              </div>
            </a>
          ))}
        </div>
      </div>

      <Footer />

      {/* ── LIGHTBOX ── */}
      {lightbox && (
        <LightboxGallery
          images={lightbox.images}
          initialIndex={lightbox.idx}
          onClose={() => setLightbox(null)}
        />
      )}
    </motion.div>
  );
}